<onyx-logo variant="signet" theme="light"></onyx-logo>
